module.exports = __webpack_public_path__ + "img/blood-types.955b3465.svg";